export const swapArr = (arr, aIndex, bIndex) => {
  const cloned = [...arr];

  const temp = cloned[aIndex];
  cloned[aIndex] = cloned[bIndex];
  cloned[bIndex] = temp;

  return cloned;
};
